import axios from 'axios'
import { getAPIUrl } from '../API'

export interface SearchPropertyByStreetNameRequest {
  streetName: string
  region: string
}

export interface StreetNameResponse {
  streetName: string
  suburb: string
  mun_name: string
  region: string
}

export type SearchPropertyByStreetNameResponse = StreetNameResponse[]

export const searchPropertyByStreetName: (
  options: SearchPropertyByStreetNameRequest,
) => Promise<SearchPropertyByStreetNameResponse> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/searchpropertybystreetname`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  if (!data.data) {
    alert(`No results found for street: ${options.streetName}`)
  }
  return data.data
}
